import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/system';


interface MainSectionPanelProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const MainSectionPanel: React.FC<MainSectionPanelProps> = ({
  children,
  sx = {}
}) => {
  return (
    <Box
      sx={{
        p: 2,
        width: '100%',
        backgroundColor: '#f9fafb',
        minHeight: '100vh',
        overflowX: 'auto',
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default MainSectionPanel;